import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/902fd129-2c69-403c-ad7d-8fe2c588c673.jpg';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-cream paper-grain" data-id="element-58" data-mp="9lbeyxpzr5c0">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-10 px-5 pb-12 pt-10 sm:gap-12 sm:px-6 sm:pb-16 sm:pt-14 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16 lg:pb-24 lg:pt-20" data-id="element-59" data-mp="4mrtszj81xkp">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-60" data-mp="xbfmvha7pr8t">
          <p className="mb-5 inline-flex items-center gap-2 rounded-full border border-sage/40 bg-oat/50 px-3.5 py-1.5 font-sans text-[10px] font-medium uppercase tracking-[0.16em] text-moss sm:mb-6 sm:px-4 sm:text-[11px] sm:tracking-[0.22em]" data-id="element-61" data-mp="ncq29gqxlsov">
            Guía digital · Método Maestro Jabonero
          </p>

          <h1 className="font-display text-[2rem] font-semibold leading-[1.1] tracking-tight text-ink sm:text-5xl lg:text-[3.5rem]" data-id="element-62" data-mp="3j893b0s41pjq">
            ¡Te enseñamos a hacer jabones{' '}
            <em className="italic text-clay" data-id="element-63" data-mp="39auqrc9b5kwp">para emprender</em>!
          </h1>

          <p className="mt-5 max-w-xl font-display text-lg leading-snug text-ink/80 sm:mt-6 sm:text-2xl" data-id="element-64" data-mp="3e9fsjg47kcn9">
            Aprendé a crear jabones artesanales premium para cuidar tu piel o
            emprender desde casa.
          </p>

          <p className="mt-4 max-w-xl font-sans text-[15px] leading-relaxed text-ink/65 sm:mt-5 sm:text-base" data-id="element-65" data-mp="358zoa4fn51hc">
            El método paso a paso para dominar la jabonería natural, formular
            recetas terapéuticas y vender productos de lujo, aunque no sepas
            nada de química.
          </p>

          <div className="mt-7 max-w-xl sm:mt-9" data-id="element-66" data-mp="2hk85u4rurxhr">
            <CtaButton note="Un solo pago · Acceso inmediato por email" data-id="element-67" data-mp="2hljas7x1bbag" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1],
        delay: 0.1
      }} className="relative mb-6 sm:mb-0" data-id="element-68" data-mp="s1rpyhl8dur4">
          <div className="absolute -left-4 -top-4 hidden h-full w-full rounded-[2rem] border border-sage/30 lg:block" data-id="element-69" data-mp="iczzyezqdkiu" />
          <img src={HERO_IMAGE} alt="Jabones artesanales con flores secas y arcillas naturales apilados sobre lino" className="relative aspect-[4/3] w-full rounded-[1.5rem] object-cover shadow-soft sm:aspect-auto sm:rounded-[2rem]" data-id="element-70" data-mp="deyh9v67vn7w" />
          <div className="absolute -bottom-4 left-4 max-w-[85%] rounded-full bg-moss px-4 py-2.5 text-center font-sans text-[10px] font-medium uppercase tracking-[0.12em] text-cream shadow-soft sm:-bottom-5 sm:left-6 sm:px-5 sm:py-3 sm:text-[11px] sm:tracking-[0.18em]" data-id="element-71" data-mp="11151dfsx0teh">
            100% natural · Sin química complicada
          </div>
        </motion.div>
      </div>
    </header>;
}